import { EncryptStorage } from 'encrypt-storage';

export  const encryptStorage = new EncryptStorage(process.env.REACT_APP_Encrypt_Storage_SECRET_KEY, {
  // export  const encryptStorage = new EncryptStorage('bySamiurRehmanDashboardAdlyticAi2022', {
    prefix: '@v.1.0',
  });